import React from 'react';

const IndustriesSection = ({ industryImages }) => {
  const industries = [
    {
      title: 'HealthCare',
      image: industryImages.HealthCareImg,
      description:
        'Improving hospital operations and enhancing value realization across all sizes.',
    },
    {
      title: 'Insurance',
      image: industryImages.insuranceImg,
      description:
        'Helping agencies build efficient workflows and better customer experiences.',
    },
    {
      title: 'On-Demand App',
      image: industryImages.ondemandImg,
      description:
        'Powering fast delivery and scheduling systems for modern on-demand solutions.',
    },
    {
      title: 'Manufacturing',
      image: industryImages.ManufacturingImg,
      description:
        'Boost productivity and automate processes with smart manufacturing systems.',
    },
    {
      title: 'Logistics',
      image: industryImages.logisticsImg,
      description:
        'Streamline fleet, inventory, and delivery with real-time logistics platforms.',
    },
  ];

  return (
    <section className="bg-gray-200 py-16 px-4 md:px-12 text-center flex flex-col items-center">
      <h2
        className="text-3xl md:text-4xl font-bold text-[#2584C6] mb-4"
        data-aos="fade-down"
      >
        Our Industries
      </h2>
      <p
        className="text-gray-600 max-w-xl mx-auto text-lg mt-3 mb-10"
        data-aos="fade-up"
      >
        Tailored digital solutions built for real-world industry needs.
      </p>

      <div className="flex flex-wrap justify-center gap-8 max-w-7xl mx-auto">
        {industries.map((industry, index) => (
          <div
            key={index}
            className="w-full sm:w-[300px] md:w-[380px]"
            data-aos="zoom-in"
          >
            <div className="flex flex-col items-center text-center bg-white p-6 rounded-xl shadow-lg transform md:hover:scale-110 transition-all duration-300 cursor-pointer">
              <img src={industry.image} alt={industry.title} className="w-16 h-16 mb-4" />
              <h3 className="text-xl font-semibold text-[#2584C6] mb-2">{industry.title}</h3>
              <p className="text-gray-600 text-sm">{industry.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default IndustriesSection;
